import React from 'react';
import api from 'api';
import moment from 'moment';
import { Spinner, Modal } from 'hyperdb-utils';
import { AppLink } from '../../../routing/containers';

class ArrivalsTable extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    let url = '/next-arrivals';
    if (this.props.fullListing) url += '?days=30';
    this.props.api.reservation.getData({
      url,
      propName: !this.props.fullListing ? 'nextArrivals' : 'fullArrivals',
    });
  }
  componentWillUnmount() {
    this.props.api.reservation.setData({ showMoreNextArrivals: false });
  }
  render() {
    const nextArrivals = !this.props.fullListing ? this.props.nextArrivals : this.props.fullArrivals;
    const today = moment();
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser) return null;
    return (
      <div className="box">
        <Spinner show={ this.props.loading } />
        <table className="table table-bordered table-striped details">
          <thead>
            <tr className="info">
              <th colSpan="7">
                Next arrivals &nbsp;
                {
                  this.props.fullListing
                    ? null
                    : <span className="btn btn-primary btn-xs" onClick={ this.toggleModalFullListing.bind(this, true) }>See more</span>
                }
              </th>
            </tr>
            <tr>
              <th>Reference</th>
              <th>Customer</th>
              <th>Arrival</th>
              <th>Property</th>
              <th>Transport</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              (nextArrivals || []).map((reservation, i) => {
                return (
                  <tr key={ i }>
                    <td>
                    {
                      currentUser.group.name === 'cleaning_staff'
                        ? reservation.reference
                        : <AppLink to={ `/daily-rental/reservations/${reservation.id}` }>
                            { reservation.reference }
                          </AppLink>
                    }
                    </td>
                    <td>{ reservation.customer.name }</td>
                    <td style={ moment(reservation.arrival_date).isSame(today, 'day') ? { fontWeight: 'bold' } : {} }>
                      { moment(reservation.arrival_date).format('DD/MM/YYYY') } { (reservation.arrival_time || '').slice(0, -3) }
                    </td>
                    <td>{ reservation.property.name }</td>
                    <td>{ reservation.arrival_transport }</td>
                    <td>
                      { reservation.leave_keys ? <i className="fas fa-key" title="Leave keys" /> : null }&nbsp;
                      { reservation.parking_reserved ? <i className="fas fa-car" title="Parking reserved" /> : null }
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
        {
          !this.props.fullListing && this.props.showMoreNextArrivals
            ? <Modal title="Next arrivals" onClose={ this.toggleModalFullListing.bind(this, false) }>
                <ArrivalsTable { ...this.props } fullListing={ true } />
              </Modal>
            : null
        }
      </div>
    );
  }
  toggleModalFullListing(bool) {
    this.props.api.reservation.setData({ showMoreNextArrivals: bool });
  }
}

export default api.connect(ArrivalsTable, 'reservation');



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/arrivals-departures/containers/ArrivalsTable.jsx